module.exports = __webpack_public_path__ + "static/img/CK.0f9a48c3.png";